<template>
  <div class="basis-list-wrapper">
    <template v-if="total === 0">
      <empty :is-search="kw ? true : false" :related-key="targetKey" />
    </template>
    <template v-else>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="list">
          <template v-for="item in listData">
            <slot name="item" :item="item" />
          </template>
        </div>
      </van-list>
    </template>
  </div>
</template>

<script>
import Empty from '@/components/empty'
import listConfig from '@/data/List'

export default {
  name: 'BasisListWrapper',
  components: { Empty },
  props: {
    targetKey: {
      type: String,
      required: true
    },
    perPage: {
      type: Number,
      default: 10
    },
    extraKeys: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    isActive: true,
    kw: undefined,
    // loading === false 时， 组件会自动的调用 onload 接口
    loading: false,
    response: {},
    listData: []
  }),
  computed: {
    total () {
      return this.response.count
    },
    finished () {
      return this.listData.length >= this.total
    },
    pagesConfig () {
      return {
        page: 0,
        perPage: this.perPage
      }
    }
  },
  watch: {
    '$route.query.kw': {
      handler (newKw, oldKw) {
        if (newKw !== oldKw && this.isActive) {
          this.kw = newKw
          this.response = {}
          this.listData = []
          this.loading = false
          this.pagesConfig.page = 0
          this.onLoad()
        }
      }
    },
    extraKeys: {
      handler (newKeys, oldKeys) {
        if (this.isActive) {
          this.response = {}
          this.listData = []
          this.loading = false
          this.pagesConfig.page = 0
          this.onLoad()
        }
      },
      deep: true
    }
  },
  mounted () {
    const { kw } = this.$route.query
    this.kw = kw
  },
  activated () {
    this.isActive = true
  },
  deactivated () {
    this.isActive = false
  },
  methods: {
    async onLoad () {
      const { Api, apiFn = 'list' } = listConfig[this.targetKey]
      try {
        if (!this.finished) {
          this.pagesConfig.page += 1
          const params = {
            kw: this.kw ? this.kw : undefined,
            ...this.pagesConfig,
            ...this.extraKeys
          }
          const response = await Api[apiFn](params)
          this.response = response
          this.updateList(response)
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      }
    },
    updateList (response) {
      const { dataKey } = listConfig[this.targetKey]
      this.listData = [...this.listData, ...response[dataKey]]
    }
  }
}
</script>

<style scoped lang="scss">
.basis-list-wrapper {

}
</style>
